/** Shared MUI sx helpers for pulsing onboarding outline highlights. */
import { alpha } from '@mui/material/styles';

/** Langzame outline-opacity-puls voor onboarding-markeringen (geen focus-spin). */
export const ONBOARDING_HIGHLIGHT_PULSE_ANIMATION =
  'onboardingHighlightPulse 1.6s ease-in-out infinite';

/** Soft end of the outline pulse (secondary.main alpha). */
const ONBOARDING_HIGHLIGHT_PULSE_MIN_ALPHA = 0.35;

/**
 * Gedeelde highlight-sx: outline in secondary.main + opacity-puls op de outline-kleur.
 * Het element zelf fade niet mee. Bij reduced-motion alleen een statische outline.
 *
 * @param {boolean} active
 * @returns {import('@mui/material').SxProps}
 */
export function getOnboardingHighlightSx(active) {
  if (!active) return {};

  return {
    outline: '2px solid',
    outlineColor: 'secondary.main',
    outlineOffset: '3px',
    '@keyframes onboardingHighlightPulse': {
      '0%, 100%': {
        outlineColor: (theme) =>
          alpha(theme.palette.secondary.main, ONBOARDING_HIGHLIGHT_PULSE_MIN_ALPHA),
      },
      '50%': {
        outlineColor: (theme) => alpha(theme.palette.secondary.main, 1),
      },
    },
    animation: ONBOARDING_HIGHLIGHT_PULSE_ANIMATION,
    '@media (prefers-reduced-motion: reduce)': {
      animation: 'none',
      outlineColor: 'secondary.main',
    },
  };
}
